import React from 'react'
import "./list.scss";
import { ListItem } from '../../index';
export const List = ({
    children,
    className,
    list,
    typographyType
}) => {
    const listClasses = [
        `bsw-list`,
        `${className ? className : ''}`
    ].join(' ');
    return (
        <ul className={listClasses}>
            {children
                ? children
                : list && list?.length > 0 &&
                list.map((item, index) => {
                    return (
                        <ListItem key={index}
                            item={item}
                            typographyType={typographyType}
                        />
                    )
                })
            }
        </ul>
    );
};